import React, { useState } from "react";
import product from "../../assets/product.png";
import { DeleteOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { removeCart } from "../../redux/ecommerce/cartSlice";
import { useTranslation } from "react-i18next";

const Cart = ({ id, count, unite_price, name, image }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [newCount, setNewCount] = useState(count);

  const handleIncrease = () => {
    setNewCount((prevCount) => prevCount + 1);
  };

  const handleDecrease = () => {
    setNewCount((prevCount) => Math.max(prevCount - 1, 1));
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { ordersCart, cart, status, error } = useSelector(
    (state) => state.cart
  );

  const handleRemoveFromCart = async (e) => {
    e.preventDefault();

    const payload = {
      cart_id: id,
    };

    try {
      await dispatch(removeCart(payload))
        .unwrap()
        .then(() => {
          message.success("Removing product to cart successful!");
          navigate("/cart");
        });
    } catch (error) {
      console.error("Error removing to cart:", error);
      message.error("Failed to add to cart. Please try again.");
    }
  };

  return (
    <div className="bg-[#FCFBFA] rounded-3xl p-5 px-7 mb-5">
      <div className="">
        <div className="lg:flex items-center">
          <div>
            <img src={image} className="rounded-3xl w-[290px] h-[200px] " />
          </div>
          <div className="lg:ml-8 max-lg:mt-4 w-full">
            <div className="flex justify-between items-center">
              <h3 className="text-[#283D63] text-xl font-bold leading-relaxed mb-3">
                {name}
              </h3>
              <button onClick={(e) => handleRemoveFromCart(e)}>
                <DeleteOutlined className="text-[#eaa182] text-2xl flex justify-end" />
              </button>
            </div>
            <div className="flex items-center">
              <p className="text-[#737E91]">Colour: </p>
              <p className="text-[#283D63] ml-2">Black</p>
            </div>
            <div className="flex items-center mt-2">
              <p className="text-[#737E91]">Shipping:</p>
              <p className="text-[#283D63] ml-2">Standard Shipping</p>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex justify-between items-center mt-4 bg-[#F8F2EB] rounded-l-3xl rounded-r-3xl w-1/2">
                <button
                  onClick={handleDecrease}
                  className="bg-[#FF773E] text-white p-3 px-4 rounded-l-3xl"
                >
                  <MinusOutlined />
                </button>
                <div className="text-lg font-semibold text-[#FF773E] ">
                  {newCount}
                </div>
                <button
                  onClick={handleIncrease}
                  className="bg-[#FF773E] text-white p-3 px-4 rounded-r-3xl"
                >
                  <PlusOutlined />
                </button>
              </div>
              <p className="text-[#374968] text-xl font-semibold">
                {unite_price} SR
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
